import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@app/components/icon/icon.component';
import { LoadingSpinnerComponent } from '@app/components/loading-spinner/loading-spinner.component';

@Component({
	selector: 'app-call-to-action-btn',
	standalone: true,
	imports: [IconComponent, LoadingSpinnerComponent],
	templateUrl: './call-to-action-btn.component.html',
	styleUrl: './call-to-action-btn.component.css',
})
export class CallToActionBtnComponent {
	@Input() showLoadingSpinner: boolean = false;
	@Input() iconName = '';
	@Input() iconColor = '';
	@Input() label = '';
	@Input() innerClass = '';

	@Output() clicked = new EventEmitter();
}
